import { useEffect, useRef, useState } from "react";
import { style } from "./StyleType";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";

import { FormControl, Helper, Label2, OptionsList, Select, SelectButton } from "./Style";
import Chevron from "./Chevron";
import OptionItem from "../../../models/OptionItem";
import SelectHelper from "../../../helpers/Selects/SelectHelper";
import TmpListItemCustom from "../TmpListItemCustom/TmpListItemCustom";

interface TmpInputSelectCustomProps {
    id: string;
    label: string;
    name: string;
    placeholder: string;
    value: OptionItem;
    helperIcon?: "info" | "error";
    helperText?: string;
    itens: OptionItem[];
    error?: boolean;
    disabled?: boolean;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}


export default function TmpInputSelectCustom(props: TmpInputSelectCustomProps) {

    const [_inputOpened, setInputOpened] = useState(false);
    const [_value, setValue] = useState<OptionItem>(props.value);
    const ref = useRef<HTMLInputElement>(null);
    const labelId = `${props.id}-label`;
    const [_indexSelected, setIndexSelected] = useState<number>(0);

    useEffect(() => {

        if (props.value) {
            let index = SelectHelper.GetIndex(props.value, props.itens);
            setIndexSelected(index);
            setValue(props.value);
        } else {
            setIndexSelected(0)
        }

    }, [props.value, props.itens]);

    const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setInputOpened(false);
        }
    };

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const _handleClick = () => {
        if (props.disabled) return;

        setTimeout(() => {
            if (!_inputOpened) {
                const itemIndex = SelectHelper.GetIndex(_value, props.itens);
                if (document !== null) {
                    let item = document.getElementById(`${props.id}-${itemIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
            }
        }, 100);
        setInputOpened(!_inputOpened);
    };

    const _handleChange = (item: OptionItem) => {
        props.onChange(convertToDefEventPara(props.name, item))
        setValue(item);
    };

    const handleListItemKeyDown = (event: any, index: number) => {
        switch (event.key) {
            case "Tab":
                setInputOpened(false);
                break;

            case "Escape":
                event.preventDefault();
                setInputOpened(false);
                break;

            case "ArrowUp":
                event.preventDefault();
                const prevIndex = index > 0 ? index - 1 : index;
                if (document !== null) {
                    let item = document.getElementById(`${props.id}-${prevIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            case "ArrowDown":
                event.preventDefault();
                const nextIndex = index < props.itens.length - 1 ? index + 1 : index;
                if (document !== null) {
                    let item = document.getElementById(`${props.id}-${nextIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            case "Enter":
                setInputOpened(false);
                _handleChange(props.itens[index]);
                if (document !== null) {
                    let item = document.getElementById(props.id);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            default:
                break;
        }
    };

    //OBS: Método usando apenas para renderizar a mensagem de erro ao passar pelo campo. A seleção do campo dispara o evento de OnChange (handleAutocompleteChange)
    const handleOnBlurChange = (newValue: any) => {
        if (props.onBlur && newValue.target.value === "" && props.value === undefined) {
            props.onBlur(convertToDefEventPara(props.name, newValue.target.value))
            console.log(props.value)
            setValue(newValue.target.value)
        }
    };

    // Passing style props to styled component
    FormControl.defaultProps = style;
    Label2.defaultProps = style;
    Select.defaultProps = style;
    SelectButton.defaultProps = style;
    OptionsList.defaultProps = style;
    Helper.defaultProps = style;

    return (
        <>
            <FormControl
                actived={_inputOpened}
                onClick={_handleClick}
                onBlur={handleOnBlurChange}
                error={props.error ? true : false}
                selected={true}
                disabled={props.disabled ? true : false}
            >
                <Label2 htmlFor={props.id} id={labelId} className="tmp-select__label">
                    {props.label}
                </Label2>

                <Select data-testid="select" ref={ref}>
                    <SelectButton type="button" id={`${props.id}-button`}>
                        {_value?.Text || props.placeholder}
                        <TmpIconCustom size="sm" icon={<Chevron />} />
                    </SelectButton>

                    <OptionsList
                        id={props.id}
                        selected={_indexSelected}
                        actived={_inputOpened}
                        disabled={props.disabled ? true : false}
                        value={(_value !== undefined ? _value.Text : null)}
                        role="listbox"
                        aria-labelledby={labelId}
                    >
                        {props.itens.map((item, index) => (
                            <TmpListItemCustom
                                id={`${props.id}-${index}`}
                                key={index}
                                label={item.Text}
                                role="option"
                                tabIndex={index === 0 ? 0 : -1}
                                aria-selected={_indexSelected === index}
                                handleClick={() => _handleChange(item)}
                                keyDown={(e: any) => { handleListItemKeyDown(e, index); }}
                            />
                        ))}
                    </OptionsList>
                </Select>
                <Helper >
                    {props.helperIcon === "error" && props.error &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconError />} />
                        </span>
                    }
                    {props.helperIcon === "info" &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconInfo />} />
                        </span>
                    }
                    {props.helperText}

                </Helper>
            </FormControl>
        </>
    );
}
